import { render, staticRenderFns } from "./DiscountPanel.vue?vue&type=template&id=67be1291&scoped=true&"
import script from "./DiscountPanel.vue?vue&type=script&lang=js&"
export * from "./DiscountPanel.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPanel.vue?vue&type=style&index=0&id=67be1291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be1291",
  null
  
)

export default component.exports